const DesignImages = {
    calendar: require('../imgs/graphicDesign/Calendar.jpg'),
    calendarPDF: require('../imgs/graphicDesign/CalendarPDF.pdf'),
    cityPoster: require('../imgs/graphicDesign/CityPoster.jpg'),
    cityPosterPDF: require('../imgs/graphicDesign/CityPosterPDF.pdf'),
    cookbook1: require('../imgs/graphicDesign/Cookbook1.jpg'),
    cookbook2: require('../imgs/graphicDesign/Cookbook2.jpg'),
    cookbook3: require('../imgs/graphicDesign/Cookbook3.jpg'),
    cookbook4: require('../imgs/graphicDesign/Cookbook4.jpg'),
    cookbook5: require('../imgs/graphicDesign/Cookbook5.jpg'),
    cookbookPDF: require('../imgs/graphicDesign/CookbookPDF.pdf'),
    adsMockupBanner: require('../imgs/graphicDesign/DigitalAdsMockup_Banner.jpg'),
    adsMockupRectangle: require('../imgs/graphicDesign/DigitalAdsMockup_Rectangle.jpg'),
    adsMockupSkyscraper: require('../imgs/graphicDesign/DigitalAdsMockup_Skyscraper.jpg'),
    landingPage: require('../imgs/graphicDesign/LandingPageMockup.jpg'),
    magazine1: require('../imgs/graphicDesign/Magazine1.jpg'),
    magazine2: require('../imgs/graphicDesign/Magazine2.jpg'),
    magazinePDF: require('../imgs/graphicDesign/MagazinePDF.pdf'),
    swissPoster: require('../imgs/graphicDesign/SwissPoster.jpg'),
    swissPosterPDF: require('../imgs/graphicDesign/SwissPosterPDF.pdf'),
  };
  
  export default DesignImages